import { createAsyncThunk } from '@reduxjs/toolkit';
import {
	getScheduledActivityListQuery as getScheduledActivityListQueryApi,
	updateScheduledActivityApi,
	downloadScheduledActivityFileApi,
} from '../../helpers/scheduled_activity/api_helper';

export const getScheduledActivityListQuery = createAsyncThunk(
	'scheduledActivity/getScheduledActivityListQuery',
	async params => {
		try {
			const response = getScheduledActivityListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const updateScheduledActivity = createAsyncThunk(
	'scheduledActivity/update',
	async ({ id, data }) => {
		try {
			const response = await updateScheduledActivityApi(id, data);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const downloadScheduledActivityFile = createAsyncThunk(
	'scheduledActivity/downloadFile',
	async id => {
		try {
			const response = await downloadScheduledActivityFileApi(id);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);
